module.exports = __webpack_public_path__ + "img/transactions.weekly.d4f85fba.png";